"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Grid_1 = require("@material-ui/core/Grid");
const ProductCard_1 = require("@components/pages/product/ProductCard");
const ProductList = ({ products = [], cartButton }) => !!(products === null || products === void 0 ? void 0 : products.length) && (React.createElement(Grid_1.default, { item: true, container: true, spacing: 3 }, products.map(product => (React.createElement(Grid_1.default, { key: product._id, item: true, container: true, direction: "column", xs: 6, md: 4, lg: 3 },
    React.createElement(ProductCard_1.default, Object.assign({}, product, { imgSize: 258, cartButton: cartButton })))))));
exports.default = ProductList;
